import type { FormGroup } from '@angular/forms';
import { DateTime } from 'luxon';
import type { OnyxTime } from '../components/timepicker/interfaces';
import { onyxMaxDateValidator } from './onyx-max-date.validator';
import { onyxMaxTimeValidator } from './onyx-max-time.validator';

export const onyxMaxDateTimeValidator =
  (
    maxDate: DateTime = DateTime.now(),
    maxTime: DateTime | OnyxTime = maxDate,
    dateControlName = 'date',
    timeControlName = 'time',
  ) =>
  (form: FormGroup): void => {
    const dateControl = form.get(dateControlName);
    const timeControl = form.get(timeControlName);
    if (!dateControl?.valid || !timeControl?.valid) return;

    const dateError = onyxMaxDateValidator(maxDate)(dateControl);
    dateControl.setErrors(dateError ?? null);

    if (dateControl.invalid) return;

    const date = DateTime.fromISO(dateControl.getRawValue());
    if (date.startOf('day') < maxDate.startOf('day')) {
      timeControl.setErrors(null);
      return;
    }

    const timeError = onyxMaxTimeValidator(maxTime)(timeControl);
    timeControl.setErrors(timeError ?? null);
  };
